const mainSearchForm = {
  flights: "voli", // translated
  tours: "Tour", // translated
  hotel: "Hotel", // translated
  hotels: "Alberghi", // translated
  services: "Servizi", // translated
  search: "RICERCA", // translated
  destination: "Destinazione", // translated
  includedServices: "Servizi inclusi", // translated
  packageDuration: "Durata del pacchetto", // translated
  checkInOut: "Check-in/out", // translated
  guests: "Ospiti", // translated
  adults: "Adulti", // translated
  children: "Bambini", // translated
  child: "Bambino", // translated
  age: "Età", // translated
  yearsOld: "Anni", // translated
  rooms: "Camere", // translated
  close: "Chiudere", // translated
  searchType: "Tipo di ricerca", // translated
  accommodation: "Struttura ricettiva", // translated
  transfers: "Trasferimenti", // translated
  toursExperiences: "Tour/Esperienze", // translated
  nights: "Notti", // translated
  days: "Giorni", // translated
  packageType: "tipo di pacchetto", // translated
  tourType: "Tipo di tour", // translated
  packages: "Pacchetti", // translated
  cars: "Macchine", // translated
  cruises: "Crociere", // translated
  passengers: "Passeggeri", // translated
  infantsInSeat: "Neonati sul sedile", // translated
  partying: "Festeggiare", // translated
  airport: "Aeroporto", // translated
  infantsOnLap: "Neonati in grembo", // translated
  origin: "Origine", // translated
  departureReturn: "Date di partenza e di ritorno", // translated
  roundTrip: "Andata e ritorno", // translated
  thingsToDo: "Cose da fare", // translated
  dream_packages: "Pacchetti da sogno", // translated
  isRoundTrip: "È andata e ritorno", // translated
};


export default mainSearchForm;
